<template>
  <div>
    <header id="header" :class="{'full': full, 'normal': !full}">
      <div id="base-header">
        <div class="navbar">
          <MarketplaceLogo />
          <AppNav class="mx-8 mt-2" :full="full" :hide-app-cta="hideAppCta" />
        </div>
      </div>
    </header>
  </div>
</template>

<script>
  import env from '~/libs/env'
  import { mapState } from 'pinia'
  import MarketplaceLogo from "~/components/marketplace/MarketplaceLogo";
  import { useCobrandStore } from '~/store/cobrand'
  import { useRootStore } from '~/store/root'
  import { useAffiliateCustomizationStore } from "~/store/affiliate-customization";

export default {
  name: 'AppHeader',
  components: { MarketplaceLogo },
  props: {
    link: String,
    full: Boolean,
    hideAppCta: Boolean,
    appNavLogo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      hpUrl: env('hpUrl'),
      useFallbackText: false
    }
  },
  computed: {
    ...mapState(useRootStore, ['affiliateId']),
    ...mapState(useCobrandStore, {
      affiliateLogoUrl: store => store.config ? store.config.logoUrl : '',
      useAffiliateLogo: store => store.affiliateCobrandEnabled
    }),
    ...mapState(useAffiliateCustomizationStore, [
      'appStyles',
      'contactInfoEnabled',
      'poweredByLendioEnabled'
    ]),
    logoLink () {
      return this.full ? '/portal' : this.link ? this.link : this.hpUrl
    },
    checkBorderStyle() {
      return this.full ? { border: 'none' } : {}
    }
  },
  methods: {
    enableDefaultLogo () {
      this.useFallbackText = true
    }
  }
}
</script>

<!-- This needs to be here to catch bundle.css stuff -->
<style>
</style>

<style lang='scss' scoped>

#header {
  #base-header {
    flex: 0 0 auto;
    margin: 0;
    background: #FFF;
    border-bottom: 1px solid #DADFE3;
    height: auto;
    a {
      transition: color 0.2s ease;
      &:visited {
        color: #2BABE2;
      }
      &:hover {
        color: #2680d0;
      }
      &:link {
        color: #2BABE2;
        text-decoration: none;
      }
    }
    .vue-brand-logo {
      display: inline-block;

      min-height: 70px;

      background-repeat: no-repeat;
      background-position: center center;

      margin-right: auto;
    }
    .vue-container {
      display: flex;
      align-content: center;
      margin: 0 auto;
    }
    .navbar{
      padding: 0;
    }
  }
  :deep(.navbar-brand) {
    padding: 0;
  }
  &.full {
    @include media-breakpoint-down(lg) {
      position: fixed;
      width: 100%;
      z-index: 100;
    }
  }
  &.normal {
    #base-header .vue-container {
        @include media-breakpoint-up(sm) {
          max-width: 540px;
        }
        @include media-breakpoint-up(md) {
          max-width: 720px;
        }
        @include media-breakpoint-up(lg) {
          max-width: 960px;
        }
        @include media-breakpoint-up(xl) {
          max-width: 1140px;
        }
    }
  }

}
</style>
